export default {"gitHash":"4cc582f470a67cc7f0a7e5ad2e9df1e069178524","gitHashShort":"4cc582f","time":1728490105853,"platform":"linux","arch":"x64"};